import React from "react";
import "./pagenotfound.css";
import Lottie from "react-lottie";
import notfound from "./404.json";
import {Link} from "react-router-dom"

function PageNotFound() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: notfound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center px-4 notFoundContainer">
          <Lottie options={defaultOptions}/>
          <span className="manpro font-semibold text-xl block my-3">
            Opps!!, Page not found
          </span>
          <Link to="/" className="manpro no-underline font-semibold text-base text-white px-4 py-2 rounded-md" style={{backgroundColor: "var(--color-5)"}}>
            Take me to homepage
          </Link>
        </div>
      </div>
    </>
  );
}

export default PageNotFound;
